import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-loader" }

import {
  onMounted,
  onBeforeUnmount,
  reactive,
  computed,
} from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLoader',
  setup(__props) {

library.add(faSpinner);

const header = reactive({
  $el: null as null | HTMLElement,
});
const minHeight = reactive({ value: null as number | null });
const minHeightPx = computed(() => (minHeight.value ? `min-height:${minHeight.value}px` : null));

const setMinHeight = () => {
  minHeight.value = window.innerHeight;

  if (header.$el) {
    minHeight.value -= header.$el.offsetHeight;
  }
};

onMounted(() => {
  header.$el = document.querySelector('header');
  window.addEventListener('resize', setMinHeight);
  window.addEventListener('load', setMinHeight);
  setMinHeight();
  for (let i = 100; i < 3000; i += 100) {
    setTimeout(setMinHeight, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setMinHeight);
  window.removeEventListener('load', setMinHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(minHeightPx.value)
    }, [
      _createElementVNode("div", null, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: "fa-solid fa-spinner",
          class: "fa-pulse"
        })
      ])
    ], 4)
  ]))
}
}

})